import { useTheme } from '../../context/ThemeContext';
import { Mail, MapPin } from 'lucide-react';

const NAV_LINKS = ['Features', 'How It Works', 'Pricing', 'For Business', 'FAQ'];

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    if (href.startsWith('#') && href !== '#') {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer
      className="relative overflow-hidden py-12"
      style={{ backgroundColor: theme.card }}
    >
      {/* Background dot pattern */}
      <div
        className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, ${theme.textMuted} 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }}
      />

      <div className="container-app relative">

        {/* Logo + description */}
        <div className="text-center mb-10">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="inline-block mb-5 hover:opacity-80 transition-opacity"
          >
            <img src="/logo.png" alt="TripData" className="h-12 object-contain mx-auto" />
          </a>

          <p
            className="text-sm leading-relaxed max-w-md mx-auto mb-6"
            style={{ color: theme.textSecondary }}
          >
            Automatic GPS mileage tracking for business and personal trips.
            Smart logging, powerful analytics, and seamless exports.
          </p>

          {/* Nav links */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            {NAV_LINKS.map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase().replace(/\s+/g, '-')}`}
                onClick={(e) => {
                  e.preventDefault();
                  const id = item === 'For Business' ? '#vouchers' : `#${item.toLowerCase().replace(/\s+/g, '-')}`;
                  scrollToSection(id);
                }}
                className="text-sm transition-colors hover:opacity-70"
                style={{ color: theme.textSecondary }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="mb-10 text-center">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
            <a
              href="mailto:hello@gpstech.co.za"
              className="flex items-center gap-2 text-sm transition-colors hover:opacity-70"
              style={{ color: theme.textSecondary }}
            >
              <Mail className="w-4 h-4" style={{ color: theme.primary }} />
              hello@gpstech.co.za
            </a>
            <span
              className="flex items-center gap-2 text-sm"
              style={{ color: theme.textSecondary }}
            >
              <MapPin className="w-4 h-4" style={{ color: theme.primary }} />
              South Africa
            </span>
          </div>
        </div>

        {/* Divider */}
        <div
          className="h-px w-full max-w-md mx-auto mb-8"
          style={{ backgroundColor: theme.border }}
        />

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: theme.textMuted }}>
            {'\u00A9'} {currentYear} TripData. All rights reserved.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="/privacy"
              className="text-xs transition-colors hover:opacity-70"
              style={{ color: theme.textMuted }}
            >
              Privacy Policy
            </a>
            <div className="flex items-center gap-1.5">
              <span className="text-xs" style={{ color: theme.textMuted }}>A division of</span>
              <a
                href="https://gpstech.co.za"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs font-medium transition-colors hover:opacity-70"
                style={{ color: theme.primary }}
              >
                GPS Tech
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Gradient line at bottom */}
      <div
        className="absolute bottom-0 left-0 right-0 h-px"
        style={{ background: `linear-gradient(90deg, transparent, ${theme.primary}40, transparent)` }}
      />
    </footer>
  );
};

export default Footer;